import { defineChannelContract } from 'shared/channels';
import { DomainMessagesTypes } from 'shared/domain/messages/message';
import type { TokenAnswer, TokenPayload } from './tokenModel';

/**
 * Contract of the worker and the page for the access token. The roles are
 * reversed: the worker asks, the page answers (only the page talks to Auth0).
 */
export const tokenContract = defineChannelContract<{
  requests: {
    getToken: { request: undefined; response: TokenAnswer };
  };
  events: {
    /** A fresh token the page sends unasked (session restored, tab resumed, late refresh). */
    [DomainMessagesTypes.tokenPush]: TokenPayload;
  };
}>('tokenChannel');
